import { AxiosError, AxiosResponse } from 'axios'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import * as requests from './requests'
import { ScreensTerms, UserProfile } from './types'
import { ResponseError, ResponseSuccess } from '../../types'

const KEY_GET_PROFILE = 'getProfile'

const KEY_GET_SCREENS_TERMS = 'getGetScreensTerms'

export const useGetProfileQuery = (token?: string) => {
  return useQuery<AxiosResponse<ResponseSuccess<UserProfile>>, AxiosError<ResponseError>>(
    KEY_GET_PROFILE,
    () => requests.getProfile(token)
  )
}

export const useUpdateProfileMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<
    AxiosResponse,
    AxiosError,
    Pick<UserProfile, 'profile_image_file_name' | 'phone_number_cell'>
  >(requests.updateProfile, {
    onSuccess: () => {
      queryClient.invalidateQueries([KEY_GET_PROFILE])
    }
  })
}

export const useGetScreensTermsQuery = () => {
  return useQuery<AxiosResponse<ResponseSuccess<ScreensTerms>>, AxiosError<ResponseError>>(
    KEY_GET_SCREENS_TERMS,
    () => requests.getScreensTerms()
  )
}

export const useUpdateScreenTermsMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<
    AxiosResponse,
    AxiosError,
    { screen_id: string; terms_id: string; accept: boolean }
  >(requests.updateScreenTerms, {
    onSuccess: () => {
      queryClient.invalidateQueries([KEY_GET_SCREENS_TERMS])
    }
  })
}
